import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import { invoke } from 'lodash';

export default class AccessibleDropdown extends React.Component {

  constructor() {
    super();
    this.state = {
      open: false,
      isFocused: false,
      pressedEscWhileOpened: false,
      pressedEnterWhileOpened: false,
      pressedEnterWhileClosed: false
    };
  }

  handleKeyDown(e) {
    if ( e.keyCode === 27 && this.state.open ) {
      e.preventDefault();
      // If dropdown is expanded and the user presses ESC, then we close the dropdown
      // This triggers the onBlur event, where we check if the event was triggered after
      // pressing ESC and keep the focus accordingly in the button
      this.setState({open: false, isFocused: true, pressedEscWhileOpened: true});
    }

    if ( (e.keyCode === 32 || e.keyCode === 40 || e.keyCode === 38)
      && this.state.isFocused && !this.state.open ) {
      // If dropdown is collapsed and the user presses SPACE, DOWN ARROW or UP ARROW we open the dropdown
      e.preventDefault();
      this.setState({open: true});
    }

    if ( e.keyCode === 13 && this.state.isFocused && this.state.open ) {
      // If dropdown is open and the user presses ENTER, we process default but also set focus
      this.setState({isFocused: true, pressedEnterWhileOpened: true})
    }

    if ( e.keyCode === 13 && this.state.isFocused && !this.state.open ) {
      // If dropdown is collapsed and the user presses ENTER, we open the dropdown
      // This will trigger the onChange event and we control if we want to open the
      // dropdown or not with the pressedEnterWhileClosed state variable
      e.preventDefault();
      this.setState({pressedEnterWhileClosed: true, open: true});
    }

    invoke(this.props, 'onKeyDown', e);
  }

  render() {
    return (
      <Dropdown
        open={this.state.open}
        aria-haspopup="listbox"
        {...this.props}
        onOpen={(e, data) => {
          this.setState({open: true});
          invoke(this.props, 'onOpen', e, data);
        }}
        onClick={(e, data) => {
          this.setState({open: true, isFocused: true});
          invoke(this.props, 'onClick', e, data);
        }}
        onFocus={(e, data) => {
          this.setState({isFocused: true});
          invoke(this.props, 'onFocus', e, data);
        }}
        onKeyDown={this.handleKeyDown.bind(this)}
        onChange={(e, data) => {
          // If this event is triggered after the user pressed enter while the dropdown was
          // closed, this means we don't want to select any value, but to open the modal
          // After returning this will trigger the onClose event, where we handle the opening/closing
          if ( this.state.pressedEnterWhileClosed ) return;
          invoke(this.props, 'onChange', e, data);
        }}
        onBlur={(e, data) => {
          if ( this.state.pressedEscWhileOpened ) {
            e.target.focus();
            this.setState({pressedEscWhileOpened: false});
          } else if ( this.state.pressedEnterWhileOpened ) {
            e.target.focus();
            this.setState({pressedEnterWhileOpened: false})
          }
          invoke(this.props, 'onBlur', e, data);
        }}
        onClose={(e, data) => {
          // We need this check because when pressing enter while closed, we want to open
          // the dropdown, and not to close it
          if ( this.state.pressedEnterWhileClosed ) this.setState({pressedEnterWhileClosed: false});

          // In all other cases, we want top close the modal
          else this.setState({open: false});

          invoke(this.props, 'onClose', e, data);
        }}
      />
    );
  }
}
